export function unSlugify(slug) {
    if (slug) {
        slug = slug
            .split('-')
            .map((part) => part.length > 0 ? part[0].toUpperCase() + part.substring(1) : '')
            .join(' ');
        slug =
            '/' +
                slug
                    .split('/')
                    .map((part) => part.length > 0 ? part[0].toUpperCase() + part.substring(1) : '')
                    .join('/');
    }
    return slug;
}
//# sourceMappingURL=unslugify.js.map